module.exports = __webpack_public_path__ + "static/ring-786028fa3e84453d05401f9d61195057.svg";